import { createTheme } from '@mui/material/styles';
import { softTone } from './colors';

// O MUI só completa (light/dark/contrastText) as cores nativas da paleta. As cores
// de produto abaixo passam pelo augmentColor aqui, em cada esquema, para os
// componentes as consumirem nativamente (`color="leadAccept"`) e o MUI derivar
// hover, contraste e estado desabilitado sozinho.
export const { augmentColor } = createTheme().palette;

const augmentAll = (colors) =>
  Object.fromEntries(
    Object.entries(colors).map(([name, main]) => [name, augmentColor({ color: { main }, name })]),
  );

const productColors = {
  // Ações de lead (aceitar/reabrir, histórico, transferir, liberar).
  // Prévia usa `primary` e encerrar usa `error`: já são exatamente essas cores.
  leadAccept: '#16A34A',
  leadHistory: '#6366F1',
  leadTransfer: '#FB923C',
  leadRelease: '#8553F4',
  // Temperatura do lead (quente/morno/frio), usada pelo chip e pelo ícone do card.
  temperatureHot: '#DC2626',
  temperatureWarm: '#F97316',
  temperatureCold: '#0EA5E9',
  leadFavorite: '#F59E0B',
  // Identidade do Agente Beworks (IA). Fica na base, fora da marca, para o
  // agente manter a cor da Beworks mesmo quando o cliente usa outra marca.
  beworksAgent: '#7C4DFF',
};

// Cores de produto calculadas pelo createAppTheme a partir de uma cor nativa
// (`from`) já resolvida em cada esquema, com o padrão do MUI quando a marca não
// a define. Acompanham a marca sem ninguém digitar hex; a marca que quiser outro
// valor define `{ main }` no esquema e a derivação é ignorada.
// - sem `derive`: a própria cor nativa (todas as variantes e o contrastText);
// - com `derive(main, scheme)`: o `main` calculado, completado pelo augmentColor.
export const derivedColors = {
  // Fundo da AppBar do dashboard: o `primary`, o padrão do MUI.
  dashboardAppBar: { from: 'primary' },
  // Tom suave do primary (pastel no light, profundo no dark; ver `softTone`).
  primarySoft: { from: 'primary', derive: softTone },
};

// Por enquanto o dark usa os mesmos tons; a #767 revisa o contraste.
const base = {
  colorSchemes: {
    light: { palette: augmentAll(productColors) },
    dark: { palette: augmentAll(productColors) },
  },
  typography: {
    // O lineHeight padrão da overline (2.66) é alto demais para os rótulos de seção.
    overline: { lineHeight: 1.6 },
  },
};

export default base;
